import { DateTimeView, Placeholder } from 'qw-ui-lib-v2';
import I18n from '../../locale';
import './TheatreGroupDetailsHeader.scss';

export default function TheatreGroupDetailsHeader({
  isLoading,
  name,
  theatreCount,
  updatedOn,
  updatedBy,
}) {
  return (
    <header className="theatre-group-detail-header">
      <div className="theatre-group-detail-header__title">
        {I18n.t('theatreGroupDetails')}
      </div>
      <div className="theatre-group-detail-header__grid">
        <div>
          <div className="theatre-group-detail-header__label">
            {I18n.t('name')}
          </div>
          <div className="theatre-group-detail-header__value">
            {isLoading ? (
              <Placeholder type="textRow" style={{ width: '70%' }} />
            ) : (
              name
            )}
          </div>
        </div>
        <div>
          <div className="theatre-group-detail-header__label">
            {I18n.t('theatres')}
          </div>
          <div className="theatre-group-detail-header__value">
            {isLoading ? (
              <Placeholder type="textRow" style={{ width: '70%' }} />
            ) : (
              theatreCount
            )}
          </div>
        </div>
        <div>
          <div className="theatre-group-detail-header__label">
            {I18n.t('lastUpdatedOn')}
          </div>
          <div className="theatre-group-detail-header__value">
            {isLoading && (
              <div>
                <Placeholder type="textRow" style={{ width: '70%' }} />
                <Placeholder type="textRow" style={{ width: '60%' }} />
              </div>
            )}
            {!isLoading && updatedOn && <DateTimeView value={updatedOn} />}
            {!isLoading && !updatedOn && '-'}
          </div>
        </div>
        <div>
          <div className="theatre-group-detail-header__label">
            {I18n.t('lastUpdatedBy')}
          </div>
          <div className="theatre-group-detail-header__value">
            {isLoading ? (
              <Placeholder type="textRow" style={{ width: '70%' }} />
            ) : (
              updatedBy || ' - '
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
